import React from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import store from "../../../../store/store";
import styled from "styled-components";
import { Box, Grid } from "@material-ui/core";
import { StyledLabel, StyledFormControl, StyledCheckLabel } from "./components";

const initialState = {};

export default class ProvidersForm extends React.Component {
	constructor(props) {
		super(props);

		const { auth } = store.getState();

		this.state = {
			id: 0,
			name: "",
			type: "EXTERNAL",
			apikey: "",
			username: "",
			password: "",
			default: false,
			active: true,
			isLoading: false,
			isEditing: false,
			userLogged: auth.user,
			providerData: {},
			errors: {},
			isDefaultInApi: false
		};

		this.api = new MutantApiService();

		this.handleChange = this.handleChange.bind(this);
		this.onCleanForm = this.onCleanForm.bind(this);
		this.submit = this.submit.bind(this);
		this.validateForm = this.validateForm.bind(this);
	}

	formIsValid = () => {
		const { name, type } = this.state;
		return name && name.trim() !== "" && IsValidName(name) && type;
	};

	componentDidMount() {
		const { id } = this.props.match.params;
		if (id) {
			this.loadProvider(id);
		}
	}

	loadProvider = async id => {
		try {
			this.setState({ isLoading: true });

			const response = await this.api.makeHttpRequest({
				method: "GET",
				url: `/provider/${id}`
			});

			const provider = response;
			console.log("provider", provider);
			this.setState({
				id: provider.id,
				name: provider.name || "",
				type: provider.type || "INTERNAL",
				apikey: provider.apikey || "",
				username: provider.username || "",
				password: "",
				default: provider.default || false,
				active: provider.active !== undefined ? provider.active : true,
				isEditing: true,
				providerData: provider,
				showPassword: false,
				showApiKey: false,
				isDefaultInApi: provider.default || false
			});
		} catch (error) {
			console.error(error);
			Swal.fire("Erro!", "Erro ao carregar dados do provedor.", "error");
		} finally {
			this.setState({ isLoading: false });
		}
	};

	toggleShowPassword = () => {
		this.setState(prevState => ({ showPassword: !prevState.showPassword }));
	};

	toggleShowApiKey = () => {
		this.setState(prevState => ({ showApiKey: !prevState.showApiKey }));
	};

	showDefaultProviderInfo = () => {
		Swal.fire({
			title: "Provedor Padrão",
			html: `
				<p style="text-align: left; font-size: 14px; line-height: 1.6;">
					O modelo definido como padrão indica qual o sintetizador está sendo atualmente utilizado como padrão pela aplicação.
					<br><br>
					Alterar esse parâmetro não altera a infraestrutura da aplicação, mas altera a listagem de vozes disponíveis para sintetização de prompts.
				</p>
			`,
			icon: "info",
			confirmButtonText: "Entendi"
		});
	};

	handleChange = event => {
		const { name, value, type, checked } = event.target;
		const newValue = type === "checkbox" ? checked : value;

		const stateUpdate = {
			[name]: name === "name" ? newValue.toUpperCase() : newValue,
			errors: {
				...this.state.errors,
				[name]: null
			}
		};

		if (name === "type" && newValue !== "INTERNAL") {
			stateUpdate.default = false;
		}

		this.setState(stateUpdate);
	};

	validateForm = () => {
		const errors = {};
		const { name, type } = this.state;

		if (!name || name.trim() === "") {
			errors.name = "Nome é obrigatório";
		} else if (!IsValidName(name)) {
			errors.name = "Nome deve conter apenas letras, números e espaços";
		}

		if (!type) {
			errors.type = "Tipo é obrigatório";
		}

		this.setState({ errors });
		return Object.keys(errors).length === 0;
	};

	submit = async e => {
		e.preventDefault();

		if (!this.validateForm()) {
			return;
		}

		try {
			this.setState({ isLoading: true });

			const {
				id,
				name,
				type,
				apikey,
				username,
				password,
				default: isDefault,
				active
			} = this.state;

			const data = {
				name: name.trim(),
				type,
				apikey: apikey.trim() || null,
				username: username.trim() || null,
				password: password.trim() || null,
				default: type === "INTERNAL" ? isDefault : false,
				active
			};

			const method = this.state.isEditing ? "PATCH" : "POST";
			const url = this.state.isEditing ? `/provider/${id}` : "/provider";

			console.log("Enviando dados:", { method, url, data });

			await this.api.makeHttpRequest({
				method,
				url,
				data
			});

			this.setState({
				successMessage: this.state.isEditing
					? "Provedor atualizado com sucesso!"
					: "Provedor criado com sucesso!"
			});
		} catch (error) {
			let errorMessage =
				error.response?.data?.messages ||
				(this.state.isEditing
					? "Erro ao atualizar provedor."
					: "Erro ao criar provedor.");
			if (Array.isArray(errorMessage)) {
				errorMessage.join(" ");
			}
			if (errorMessage.includes("Provider with this name already exists")) {
				errorMessage = "Já existe um provedor com este nome.";
			}
			this.setState({ errorMessage });
		} finally {
			this.setState({ isLoading: false });

			const { successMessage, errorMessage } = this.state;
			if (successMessage) {
				await Swal.fire({
					title: "Sucesso!",
					text: successMessage,
					icon: "success",
					cancelButtonText: "Sair"
				});
				this.props.history.push("/dashboard/providers");
			} else if (errorMessage) {
				await Swal.fire("Erro!", errorMessage, "error");
			}
		}
	};

	onCleanForm = () => {
		this.setState({
			...initialState,
			name: "",
			type: "INTERNAL",
			apikey: "",
			username: "",
			password: "",
			default: false,
			active: true,
			errors: {}
		});
	};

	render() {
		const {
			isLoading,
			name,
			type,
			apikey,
			username,
			password,
			default: isDefault,
			active,
			errors,
			isEditing,
			isDefaultInApi
		} = this.state;

		return (
			<>
				<Loading isLoading={isLoading} />
				<AdminTitle
					title={isEditing ? "Editar Provedor de TTS" : "Novo Provedor de TTS"}
					subtitle={
						isEditing
							? "Atualize as informações do provedor"
							: "Preencha os dados para criar um novo provedor"
					}
				/>
				<Card className="mt-4" style={{ width: "100%", margin: "0 auto" }}>
					{" "}
					<Box>
						<StyledCardBody minHeight="550px">
							<Grid container>
								<Grid
									item
									xs={12}
									sm={12}
									style={{
										marginBottom: "30px"
									}}
								>
									<Form onSubmit={this.submit}>
										<Form.Row>
											<Col md={12}>
												<Form.Group>
													<StyledLabel htmlFor="name">Nome *</StyledLabel>
													<StyledFormControl
														type="text"
														name="name"
														id="name"
														value={name}
														onChange={this.handleChange}
														placeholder="Digite o nome do provedor"
														isInvalid={!!errors.name}
														disabled={this.state.isEditing}
														title={this.state.isEditing ? "O nome do provedor não pode ser alterado" : ""}
													/>
													{errors.name && (
														<Form.Control.Feedback type="invalid">
															{errors.name}
														</Form.Control.Feedback>
													)}
												</Form.Group>
											</Col>
										</Form.Row>
										<Form.Row>
											<Col md={12}>
												<Form.Group>
													<StyledLabel
														htmlFor="type"
														style={{ marginRight: "10px" }}
													>
														Tipo *
													</StyledLabel>
													<StyledFormControl
														as="select"
														name="type"
														id="type"
														value={type}
														onChange={this.handleChange}
														isInvalid={!!errors.type}
													>
														<option value="EXTERNAL">Externo</option>
														<option value="INTERNAL">Interno</option>
													</StyledFormControl>
													{errors.type && (
														<Form.Control.Feedback type="invalid">
															{errors.type}
														</Form.Control.Feedback>
													)}
												</Form.Group>
											</Col>
										</Form.Row>
										<Form.Row>
											<Col md={12}>
												<Form.Group>
													<StyledLabel htmlFor="apikey">API Key</StyledLabel>
													<div style={{ position: "relative" }}>
														<StyledFormControl
															type={this.state.showApiKey ? "text" : "password"} // Alterna entre "text" e "password"
															name="apikey"
															id="apikey"
															value={apikey}
															onChange={this.handleChange}
															placeholder="Digite a API Key (opcional)"
														/>
														<button
															type="button"
															onClick={this.toggleShowApiKey}
															style={{
																position: "absolute",
																right: "10px",
																top: "50%",
																transform: "translateY(-50%)",
																background: "none",
																border: "none",
																cursor: "pointer"
															}}
														>
															{this.state.showApiKey ? "Ocultar" : "Exibir"}
														</button>
													</div>
												</Form.Group>
											</Col>
										</Form.Row>
										<Form.Row>
											<Col md={12}>
												<Form.Group>
													<StyledLabel htmlFor="username">Usuário</StyledLabel>
													<StyledFormControl
														type="text"
														name="username"
														id="username"
														value={username}
														onChange={this.handleChange}
														placeholder="Digite o usuário (opcional)"
														autoComplete="off"
													/>
												</Form.Group>
											</Col>
										</Form.Row>
										<Form.Row>
											<Col md={12}>
												<Form.Group>
													<StyledLabel htmlFor="password">Senha</StyledLabel>
													<div style={{ position: "relative" }}>
														<StyledFormControl
															type={
																this.state.showPassword ? "text" : "password"
															}
															name="password"
															id="password"
															value={password}
															onChange={this.handleChange}
															placeholder="Digite a senha (opcional)"
														/>
														<button
															type="button"
															onClick={this.toggleShowPassword}
															style={{
																position: "absolute",
																right: "10px",
																top: "50%",
																transform: "translateY(-50%)",
																background: "none",
																border: "none",
																cursor: "pointer"
															}}
														>
															{this.state.showPassword ? "Ocultar" : "Exibir"}
														</button>
													</div>
												</Form.Group>
											</Col>
										</Form.Row>


										{type !== "INTERNAL" && !isDefaultInApi && (
											<Form.Row>
												<Col md={12}>
													<small style={{ color: "gray" }}>
														Provedor externo não pode ser definido como padrão.
													</small>
												</Col>
											</Form.Row>
										)}
										{!isDefaultInApi && (
											<Form.Row>
												<Col md={12}>
													<Form.Group>
														<StyledCheckLabel>
															<input
																type="checkbox"
																name="active"
																id="active"
																checked={active}
																onChange={this.handleChange}
																disabled={isDefault}
															/>
															<span>Ativo</span>
														</StyledCheckLabel>
														{isDefault && (
															<small style={{ color: "gray" }}>
																Não é possível desativar um provedor padrão.
															</small>
														)}
													</Form.Group>
												</Col>
											</Form.Row>
										)}
									</Form>
								</Grid>
							</Grid>
						</StyledCardBody>
					</Box>
				</Card>
				<FormActions
					module="providers"
					isEdit={isEditing}
					formIsValid={this.formIsValid()}
					onCleanForm={this.onCleanForm}
					onSubmit={this.submit}
					hideReload
				/>
			</>
		);
	}
}
